var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{attrs:{"depressed":"","medium":"","color":_vm.color,"type":_vm.buttonType,"disabled":_vm.disabled},on:{"click":_vm.clickHandler}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }